export default {
  list: [],
  selected: {}
}